import React from 'react';
import PropTypes from 'prop-types';

import { IntegrationsForm } from 'components/organisms/IntegrationsForm';
import { useAllyIntegrations } from '../hooks/useAllyIntegrations';

export const AllyIntegrations = ({ network }) => {
  const { isLoading, handleContinue, handleSkip, handleGoogleSyncComplete } = useAllyIntegrations({ network });

  return (
    <IntegrationsForm
      network={network}
      title="Sync your contacts"
      description={`Install our Chrome extension, automatically sync your connections, and help ${network?.name} find warm introductions.`}
      onContinue={handleContinue}
      onSkip={handleSkip}
      isLoading={isLoading}
      linkedinSyncBasePath={`/onboarding/${network?.slug}/ally-signup/linkedin`}
      canSkipWithoutIntegration={false}
      onGoogleSyncComplete={handleGoogleSyncComplete}
    />
  );
};

AllyIntegrations.propTypes = {
  network: PropTypes.object.isRequired,
};
